import React from 'react';

import logos from '@/public/images/theme_features/logos.svg';

import NextImage from '../UI/nextImage/NextImage';
import { Title } from '../UI/title/Title';

import styles from './LogoBlock.module.scss';

const LogoBlock = () => {
    return (
        <div className={styles.logo}>
            <div className={styles.logo__info}>
                <Title text="Logo Positioning Variations" size="xs" className={styles.heading} />
                <p className={`excerpt body-md ${styles.excerpt}`}>
                    Experiment with different logo placements to give your site a unique and
                    professional appearance
                </p>
            </div>
            <div className={styles.logo__block}>
                <NextImage
                    src={logos.src}
                    alt="Logo Back"
                    fill
                    loading="lazy"
                    sizes="
                            (max-width: 768px) 90vw, 
                            (max-width: 1024px) 45vw, 
                            (max-width: 1300px) 30vw, 
                                                384px"
                />
            </div>
        </div>
    );
};

export default LogoBlock;
